import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { UserVuetifyPreset } from 'vuetify'

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

const themes = [
    {
        light: {
            primary: '#3F51B5',
            secondary: '#283593',
            accent: '#B0BEC5',
        }
    },
    {
        light: {
            primary: '#3F51B5',
            secondary: '#5C6BC0',
            accent: '#FFC107',
        }
    },
    {
        light: {
            primary: '#9E9E9E',
            secondary: '#BDBDBD',
            accent: '#4b5155',
        }
    },
]

const opts: Partial<UserVuetifyPreset> = {
    theme: {
        themes: themes[0],
    },
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
}

export default new Vuetify(opts)